export const environment = {
  production: false,
  api_basepoint: '/api/',
  api: (...fragments: (string | number)[]) => environment.api_basepoint + fragments.join('/'),
  debug: (...stuff: any[]) => console.debug(...stuff),
  error: (...stuff: any[]) => console.error(...stuff)
};
